<div fxLayout="column" style="padding-left: 25px">

    <div fxLayout="row" class="pageTitle">
        <span fxFlex="grow">Λίστα χρηστών</span>
        <span> <mat-icon (click)="close()">
                close
            </mat-icon>
       </span>
    </div>


    <div *ngIf="isLoading">
        <app-loading></app-loading>
    </div>

    <div *ngIf="!isLoading" style="height: 550px; overflow-y: auto">

        <table mat-table [dataSource]="students"  class="mat-elevation-z0">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="displayName">
                <th mat-header-cell *matHeaderCellDef> Ον/Επώνυμο</th>
                <td mat-cell *matCellDef="let element"> {{element.displayName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="school">
                <th mat-header-cell *matHeaderCellDef> Οργανισμός </th>
                <td mat-cell *matCellDef="let element"> {{element.school}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="className">
                <th mat-header-cell *matHeaderCellDef> Κατηγορία </th>
                <td mat-cell *matCellDef="let element"> {{element.className}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="fatherDisplayName">
                <th mat-header-cell *matHeaderCellDef> Επικοινωνία 1 </th>
                <td mat-cell *matCellDef="let element"> {{element.fatherDisplayName}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="motherDisplayName">
                <th mat-header-cell *matHeaderCellDef> Επικοινωνία 2 </th>
                <td mat-cell *matCellDef="let element"> {{element.motherDisplayName}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </table>

    </div>
</div>
